import styled from 'styled-components'

import { Typography } from '@/components/ui/typography'

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
}))

export const SwitchContainer = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const RoomItem = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
}))

export const RoomContent = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'space-between',
}))

export const RoomUrl = styled(Typography)(() => ({
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const RoomActions = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexShrink: 0,
  gap: theme.space['8'],
}))
